import React from 'react'
import { modalActions } from 'store/modal'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { getBaseSiteIdFromStudy } from 'utils/misc'
import SurveyView from '../components/SurveyView'
import { duplicateItem, toggleAllItemAttribute, mediaActions, surveyActions } from '../modules/Survey'
import { instrumentActions, metadataActions } from '../../../modules/Instrument'
import { downloadInstrument } from '../../../../InstrumentsPage/modules/Instruments'
import { isVersionUatOrLive } from '../../../../../../../../../../../utils/studyConfigUtils'

const mapDispatchToProps = {
  duplicateItem,
  toggleAllItemAttribute,
  ...surveyActions,
  ...mediaActions,
  ...instrumentActions,
  ...metadataActions,
  ...modalActions,
  downloadInstrument,
}

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const path = state.location?.pathname === '/instruments/createinstrument' ? 'create' : 'edit'
  const { instrumentReducer, surveyEditor, loading, study, user } = state
  const { studyVersionList } = study || {}
  const instrument = instrumentReducer?.instrument || {}
  const { type, title, url } = instrument
  const survey = surveyEditor?.survey

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  return {
    id: survey?.id,
    type,
    url,
    instrumentTitle: title,
    survey,
    article: surveyEditor?.article,
    isLoading: loading?.general,
    questionNumbers: survey?.questionNumbers,
    wordCount: surveyEditor?.wordCount,
    version: instrument.metadata?.version ?? 1,
    reviewScreen: instrument.metadata?.review_screen?.enabled,
    path,
    studyID: study?.currentStudy?.id,
    siteID: getBaseSiteIdFromStudy(study),
    errors: surveyEditor?.surveyErrors,
    study: study?.currentStudy,
    userId: user?.id,
    isReadOnlyState,
    studyVersionID,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  return (props.isLoading || props.type === '') ? <Loader active /> : <SurveyView {...props} />
})
